import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';

interface Props {
  handleClose: () => void;
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const Toast: React.FC<Props> = (props) => {
  const { handleClose, icon, title, description } = props;

  return (
    <div className="px-4 py-3 w-full min-w-sm rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-surface-accent-2">
      <div className="flex items-start">
        <div className="flex items-center justify-center w-8 h-8 border rounded-full">
          <div className="flex-shrink-0">{icon}</div>
        </div>
        <div className="ml-3 flex-1 pt-0.5">
          <h4 className="text-sm font-medium text-accent-1">{title}</h4>
          <p className="mt-1 text-sm text-gray-500">{description}</p>
        </div>
        <div className="ml-4 flex flex-shrink-0">
          <button
            type="button"
            className="inline-flex rounded-m text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={handleClose}
          >
            <span className="sr-only">Close</span>
            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast;
